var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getServerConfig from '../../config/getServerConfig';
const callTokenEndpoint = (body) => __awaiter(void 0, void 0, void 0, function* () {
    const { tokenEndpoint } = getServerConfig();
    const response = yield fetch(tokenEndpoint, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
        },
        body,
    });
    switch (response.status) {
        case 200:
            return yield response.json();
        case 503:
        case 429:
            throw new Error('Please retry');
        default:
            throw new Error('Smth bad happened');
    }
});
export default callTokenEndpoint;
//# sourceMappingURL=callTokenEndpoint.js.map